import excelIcon from '@/assets/almedalsveckan_logo.svg';
import { cn } from '@/utils';

export const AlmdedalenIcon = ({ className = '' }: { className?: string } = { className: '' }) => (
  <img src={excelIcon} alt="Almedalen ikon" className={cn('w-4 h-4 mr-2', className)} />
);
